import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cb6928b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clubMatchSchedule" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "center display-2" }, "Club Tournament Match List", -1))
const _hoisted_3 = { class: "clubMatchScheduleFull" }
const _hoisted_4 = { class: "layout gutter--xl" }
const _hoisted_5 = { class: "row justify--space-around" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "row justify--space-around" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Pdf udskrift")
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Se stillingen")
const _hoisted_14 = { class: "va-table-responsive" }
const _hoisted_15 = { class: "va-table va-table--striped centerTable" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Kampnr"),
    /*#__PURE__*/_createElementVNode("th", null, "Kampdato"),
    /*#__PURE__*/_createElementVNode("th", null, "Ny Kampdato"),
    /*#__PURE__*/_createElementVNode("th", null, "Hjemmehold"),
    /*#__PURE__*/_createElementVNode("th", null, "Udehold"),
    /*#__PURE__*/_createElementVNode("th", { class: "mobile" }, "Kommentar"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Resultat"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "colmatchnumb" }
const _hoisted_19 = { class: "colmatchorigdatetime" }
const _hoisted_20 = { class: "colmatchnewdatetime" }
const _hoisted_21 = { class: "colmatchteamname" }
const _hoisted_22 = { class: "colmatchteamname" }
const _hoisted_23 = { class: "mobile colmatchcomment" }
const _hoisted_24 = { class: "center colmatchscores va-code-snippet" }
const _hoisted_25 = { class: "colmatchdetails" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Detaljer")
const _hoisted_28 = { class: "clubMatchScheduleMobile" }
const _hoisted_29 = { class: "layout gutter--md" }
const _hoisted_30 = { class: "row justify--space-around mb-2" }
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = { class: "flex" }
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = { class: "row justify--space-around" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Se stillingen")
const _hoisted_37 = { class: "row align--baseline" }
const _hoisted_38 = { class: "center" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Detaljer")
const _hoisted_41 = { class: "display-5 center" }
const _hoisted_42 = { class: "va-table-responsive" }
const _hoisted_43 = {
  class: "va-table va-table--striped rankingTable",
  style: {"width":"100%"}
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Nr"),
    /*#__PURE__*/_createElementVNode("th", null, "Hold"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Kampe"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Vundne"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Uafgjorte"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Tabte"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Score"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Point")
  ])
], -1))
const _hoisted_45 = { class: "center" }
const _hoisted_46 = { class: "center" }
const _hoisted_47 = { class: "center" }
const _hoisted_48 = { class: "center" }
const _hoisted_49 = { class: "center" }
const _hoisted_50 = { class: "center" }
const _hoisted_51 = { class: "layout gutter--xl" }
const _hoisted_52 = { class: "row justify--center" }
const _hoisted_53 = { class: "flex" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_55 = { class: "center display-4 mb-4 mt-4" }
const _hoisted_56 = { class: "va-table-responsive tableContainer" }
const _hoisted_57 = { class: "va-table va-table--striped tableItem" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Kampnr."),
    /*#__PURE__*/_createElementVNode("th", null, "Kampdato"),
    /*#__PURE__*/_createElementVNode("th", null, "Ny kampdato"),
    /*#__PURE__*/_createElementVNode("th", null, "Hjemmehold"),
    /*#__PURE__*/_createElementVNode("th", null, "Udehold")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.tournamentSeasonValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tournamentSeasonValue) = $event)),
              options: _ctx.tournamentSeasonOptions,
              "track-by": (v) => v.id,
              "text-by": (v) => v.name,
              label: "Sæson",
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.clubRaekkeValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.clubRaekkeValue) = $event)),
              options: _ctx.clubRaekke,
              "track-by": (v) => v.id,
              "text-by": (v) => v.name,
              label: "Raekke",
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.teamFilterValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.teamFilterValue) = $event)),
              options: _ctx.teamFilterOptions,
              "track-by": (v) => v.teamId,
              "text-by": (v) => v.teamName,
              label: "Filtrer efter hold",
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_va_button, {
              color: "info",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadPdf())),
              disabled: _ctx.isGetRankingButtonDisabled
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_va_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getRanking())),
              disabled: _ctx.isGetRankingButtonDisabled
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("table", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clubTournamentMatchList, (match) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: Number(match.id),
                class: _normalizeClass(match.id === Number(_ctx.selectedMatch) && 'selectedMatch'),
                id: match.id === Number(_ctx.selectedMatch) && 'selectedMatchDesktop'
              }, [
                _createElementVNode("td", _hoisted_18, _toDisplayString(match.kampprogram_kampnr), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_dato))), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(match.kampprogram_nydato === null ? '' : _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_nydato))), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(match.kampprogram_hjemmehold.hold_holdnavn), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(match.kampprogram_udehold.hold_holdnavn), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.getEnumComment(match.kampprogram_afb_udb) + (match.kampprogram_kommentar === null ? '' : (match.kampprogram_afb_udb === null ? match.kampprogram_kommentar : ' ; ' + match.kampprogram_kommentar))), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.getScores(Number(match.id))), 1),
                _createElementVNode("td", _hoisted_25, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.setSelectedMatch(match))
                  }, [
                    _createVNode(_component_router_link, {
                      to: ('/turneringer/kampseddel/' + Number(match.id).toString())
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ], 8, _hoisted_26)
                ])
              ], 10, _hoisted_17))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.tournamentSeasonValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tournamentSeasonValue) = $event)),
              options: _ctx.tournamentSeasonOptions,
              "track-by": (v) => v.id,
              "text-by": (v) => v.name,
              label: "Sæson",
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.clubRaekkeValue,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.clubRaekkeValue) = $event)),
              options: _ctx.clubRaekke,
              "track-by": (v) => v.id,
              "text-by": (v) => v.name,
              label: "Raekke",
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.teamFilterValue,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.teamFilterValue) = $event)),
              options: _ctx.teamFilterOptions,
              "track-by": (v) => v.teamId,
              "text-by": (v) => v.teamName,
              label: "Filtrer efter hold",
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_va_button, {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getRanking())),
              disabled: _ctx.isGetRankingButtonDisabled
            }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clubTournamentMatchList, (match) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex sm6 xs12",
              key: Number(match.id)
            }, [
              _createVNode(_component_va_card, {
                class: _normalizeClass(match.id === Number(_ctx.selectedMatch) && 'selectedMatch'),
                id: match.id === Number(_ctx.selectedMatch) && 'selectedMatchMobile'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_card_content, null, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, "Kampnr.: " + _toDisplayString(match.kampprogram_kampnr), 1),
                      _createElementVNode("p", null, "Kampdato: " + _toDisplayString(_ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_dato))), 1),
                      _createElementVNode("p", null, "Ny kampdato: " + _toDisplayString(match.kampprogram_nydato === null ? '' : _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_nydato))), 1),
                      _createElementVNode("p", null, "Hjemmhold: " + _toDisplayString(match.kampprogram_hjemmehold.hold_holdnavn), 1),
                      _createElementVNode("p", null, "Udehold: " + _toDisplayString(match.kampprogram_udehold.hold_holdnavn), 1),
                      _createElementVNode("p", null, "Kommentar: " + _toDisplayString(_ctx.getEnumComment(match.kampprogram_afb_udb) + (match.kampprogram_kommentar === null ? '' : (match.kampprogram_afb_udb === null ? match.kampprogram_kommentar : ' ; ' + match.kampprogram_kommentar))), 1),
                      _createElementVNode("p", null, "Resultat: " + _toDisplayString(_ctx.getScores(Number(match.id))), 1),
                      _createElementVNode("p", _hoisted_38, [
                        _createElementVNode("span", {
                          onClick: ($event: any) => (_ctx.setSelectedMatch(match))
                        }, [
                          _createVNode(_component_router_link, {
                            to: ('/turneringer/kampseddel/' + Number(match.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_40
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ], 8, _hoisted_39)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class", "id"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.rankingsModal,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rankingsModal) = $event)),
      width: "50%"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h5", _hoisted_41, _toDisplayString('Stillingen i ' + _ctx.clubRaekkeValue.name), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("table", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamRankingsArray, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(item.teamName), 1),
                  _createElementVNode("td", _hoisted_45, _toDisplayString(item.matches), 1),
                  _createElementVNode("td", _hoisted_46, _toDisplayString(item.won), 1),
                  _createElementVNode("td", _hoisted_47, _toDisplayString(item.tied), 1),
                  _createElementVNode("td", _hoisted_48, _toDisplayString(item.lost), 1),
                  _createElementVNode("td", _hoisted_49, _toDisplayString(item.wonScore + '-' + item.lostScore), 1),
                  _createElementVNode("td", _hoisted_50, _toDisplayString(item.points), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_va_button, {
                color: "secondary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.rankingsModal = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_54
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_vue3_html2pdf, {
      "show-layout": false,
      "float-layout": true,
      "preview-modal": true,
      "enable-download": false,
      "paginate-elements-by-height": 1400,
      filename: _ctx.clubRaekkeValue.name + ', ' + _ctx.tournamentSeasonValue.name,
      "pdf-quality": 2,
      "manual-pagination": false,
      "pdf-format": "a4",
      "pdf-orientation": "portrait",
      "pdf-content-width": "100%",
      ref: "html2Pdf"
    }, {
      "pdf-content": _withCtx(() => [
        _createElementVNode("h4", _hoisted_55, _toDisplayString(_ctx.clubRaekkeValue.name + ', ' + _ctx.tournamentSeasonValue.name), 1),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("table", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clubTournamentMatchList, (match) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: Number(match.id)
                }, [
                  _createElementVNode("td", null, _toDisplayString(match.kampprogram_kampnr), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_dato))), 1),
                  _createElementVNode("td", null, _toDisplayString(match.kampprogram_nydato === null ? '' : _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(match.kampprogram_nydato))), 1),
                  _createElementVNode("td", null, _toDisplayString(match.kampprogram_hjemmehold.hold_holdnavn), 1),
                  _createElementVNode("td", null, _toDisplayString(match.kampprogram_udehold.hold_holdnavn), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["filename"])
  ]))
}